/*
 * @Author: changcheng
 * @LastEditTime: 2023-02-10 11:02:29
 */
import { useSelector } from "react-redux";
import { RootState } from "@root/store/index";
import { useEffect } from "react";
export default function VideoPlayer() {
  const { siteid, rate_allow_change, progressbar_enable, vid, watchStartTime } =
    useSelector((state: RootState) => state.videoInfo);
  const initVideo = () => {
    if (window.createCCH5Player) {
      window.ccPlayerStatus = window.createCCH5Player({
        vid,
        siteid,
        autoStart: true,
        width: "100%",
        rate: 1,
        height: "100%",
        banDrag: "false",
        playtype: 1,
        rate_allow_change,
        // 是否可以拖动
        progressbar_enable,
        parentNode: document.getElementById("livePlayer"),
        watchStartTime,
        rate_array: [2, 1.5, 1, 0.8],
      });
    }
  };
  useEffect(() => {
    if (!window.ccPlayerStatus || vid) {
      initVideo();
    }
    return () => {
      window.ccPlayerStatus = null;
    };
  }, [vid]);
  return <div id="livePlayer"></div>;
}
